// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"dc9e1da6","212":"8bf482e0","530":"9927b1bc","617":"f72aae52","855":"8cd02046","922":"1f56b846","926":"9e5fcab5"}[chunkId] + ".js";
};